import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { usePortalAuth } from "../../components/PortalAuthContext";
import { Loader2, AlertCircle } from "lucide-react";

export default function PortalMagic() {
  const { token } = useParams();
  const { consumeMagic, formatApiError } = usePortalAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [err, setErr] = useState("");

  useEffect(() => {
    // Intentional one-shot effect: only the `token` from URL should trigger
    // a re-consume. The other deps (auth/router callbacks, location.search)
    // are read inside but should not re-fire the magic exchange.
    let cancel = false;
    (async () => {
      try {
        await consumeMagic(token);
        if (cancel) return;
        const next = new URLSearchParams(loc.search).get("next") || "/portal";
        navigate(next, { replace: true });
      } catch (e) {
        if (!cancel) setErr(formatApiError(e));
      }
    })();
    return () => { cancel = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--canvas)" }} data-testid="portal-magic-page">
      <div className="card p-8 max-w-md w-full text-center">
        {!err ? (
          <>
            <Loader2 size={28} className="animate-spin mx-auto mb-3" style={{ color: "var(--accent)" }} />
            <div className="overline mb-2">Signing you in</div>
            <div className="font-heading text-xl" style={{ fontWeight: 500 }}>One moment…</div>
          </>
        ) : (
          <>
            <AlertCircle size={28} className="mx-auto mb-3" style={{ color: "var(--accent)" }} />
            <div className="font-heading text-xl mb-1" style={{ fontWeight: 500 }}>Link not valid</div>
            <div className="text-sm text-[var(--ink-3)] mb-4" data-testid="portal-magic-error">{err}</div>
            <button onClick={() => navigate("/portal/login")} className="btn-secondary" data-testid="portal-magic-fallback">
              Go to sign in
            </button>
          </>
        )}
      </div>
    </div>
  );
}
